import { z } from "zod";
/**
 * Answer to `POST /embed-sessions/consume`: the customer app, framed on TRY's Min side, trades the
 * `__session` cookie TRY set for a Firebase custom token. The cookie itself is not part of this
 * contract: it travels `HttpOnly` in the request header, and Firebase Hosting forwards it to the
 * function by that one name. Partner contract: `docs/TRY/embed-signin.md`.
 */
export const embedSessionConsumeResponseSchema = z.object({ customToken: z.string() });
